"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var GradacaoPrimaria;
(function (GradacaoPrimaria) {
    GradacaoPrimaria["AzulFillMU50"] = "#E8F4FA";
    GradacaoPrimaria["AzulFillMU100"] = "#D9EDF6";
    GradacaoPrimaria["AzulFillMU200"] = "#B4DBED";
    GradacaoPrimaria["AzulFillMU300"] = "#8EC8E3";
    GradacaoPrimaria["AzulFillMU400"] = "#69B6DA";
    GradacaoPrimaria["AzulMU500"] = "#43A4D1";
    GradacaoPrimaria["AzulMedioMU600"] = "#0172CB";
    GradacaoPrimaria["AzulFill700"] = "#015BA2";
    GradacaoPrimaria["AzulFillMU800"] = "#01447A";
    GradacaoPrimaria["AzulEscuroMU900"] = "#073654";
})(GradacaoPrimaria || (GradacaoPrimaria = {}));
exports.default = GradacaoPrimaria;
